var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionmenuNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M338.34,61.37a2.237,2.237,0,1,1,2.237,2.212A2.225,2.225,0,0,1,338.34,61.37Zm0-7.747a2.237,2.237,0,1,1,2.237,2.212A2.225,2.225,0,0,1,338.34,53.622Zm0-7.761a2.237,2.237,0,1,1,2.237,2.212A2.225,2.225,0,0,1,338.34,45.862Z",
    transform: "translate(-328.34 -41.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionmenuNew);
export default __webpack_public_path__ + "static/media/optionmenu-new.6cba9a89a0946fe934f91d0487caebe8.svg";
export { ForwardRef as ReactComponent };